import type { HabitFrequency } from '@/types';

// Human labels for the frequency enum — raw values ("custom") must never
// reach copy. Lowercase, mid-sentence friendly.
const LABELS: Record<HabitFrequency, string> = {
  daily: 'every day',
  weekdays: 'weekdays',
  weekends: 'weekends',
  custom: 'custom days',
};

export const frequencyLabel = (f: HabitFrequency): string => LABELS[f];
